import { FC } from 'react';

import {
    SkeletonDescriptionHeading,
    SkeletonDescriptionParagraphWrapper,
    SkeletonDescriptionText,
    SkeletonDescriptionWrapper,
} from './ProductDetailsSkeleton.styles';

export const ProductDescriptionSkeleton: FC = () => (
    <SkeletonDescriptionWrapper>
        <SkeletonDescriptionHeading />
        <SkeletonDescriptionParagraphWrapper>
            <SkeletonDescriptionText />
            <SkeletonDescriptionText $isShorter={true} />
            <SkeletonDescriptionText />
        </SkeletonDescriptionParagraphWrapper>
    </SkeletonDescriptionWrapper>
);
